// SAO LƯU DỮ LIỆU PLUGIN LÊN BOSS (07/10/2026 — người dùng chốt "Sao lưu lên Boss + mã cố định").
// Vì sao: dữ liệu của plugin nằm ở MÁY (IndexedDB "kichban" + chrome.storage.local) và gắn với MÃ TIỆN ÍCH. Tiện ích giải nén không có "key"
// thì mã tiện ích suy từ ĐƯỜNG DẪN thư mục → nạp từ thư mục khác / gỡ rồi cài lại = mã mới = mất sổ cái (chống đăng trùng), lịch sử chạy, bản đã học…
// Plugin định kỳ (mỗi ngày + trước khi tự nạp lại bản mới) gửi một BẢN SAO (JSON nén gzip) lên Boss; cài mới / đổi mã thì kéo về và GỘP an toàn.
//
// Dùng chung bot (src/background/sao-luu.ts) và Boss (server/src/plugin-sao-luu.ts): hằng giới hạn, dạng bản sao, kiểm hợp lệ, đếm, nén/giải nén.
//
// CÓ trong bản sao: sổ cái (ledger), lần chạy ĐÃ KẾT THÚC (bỏ ảnh data:), bản đã học (bundles), kịch bản YAML (scripts) và các khoá storage trong
// KHOA_SAO_LUU (cài đặt, lịch, bộ đếm hạn mức, hồ sơ, khối tuỳ chỉnh, luật chẩn đoán, xoay từ khoá, ảnh đã dùng, mã máy…).
// KHÔNG có (KHOA_KHONG_SAO_LUU): mật khẩu/khoá API ("secrets" — chỉ ghi TÊN để báo người dùng nhập lại), token ghép cặp ("boss"), mã điều khiển
// cục bộ, ảnh dạy (shots — nặng, chỉ để minh hoạ), bản đồ Boss tải về (Boss gửi lại), trạng thái tạm của service worker.

export const DANG_SAO_LUU = "kichban-sao-luu" as const;
export const PHIEN_BAN_SAO_LUU = 1 as const;

/** Bản NÉN (gzip) tối đa gửi lên Boss. base64 trong JSON ≈ 4/3 → 5,4 MB < MAX_BODY 8 MB của máy chủ. */
export const SL_BYTE_TOI_DA = 4 * 1024 * 1024;
/** JSON gốc tối đa (giải nén ở Boss có chặn — chống "bom nén"). */
export const SL_GOC_TOI_DA = 48 * 1024 * 1024;
/** Boss giữ N bản mới nhất của mỗi bot (bản cũ hơn bị xoá). */
export const SL_GIU_MOI_BOT = 5;
/** Hai lần bot TỰ gửi cách nhau ít nhất chừng này (Boss trả 429 nếu sớm hơn). */
export const SL_KHOANG_TOI_THIEU_MS = 5 * 60_000;
/** Chu kỳ sao lưu định kỳ của plugin. */
export const SL_CHU_KY_MS = 24 * 3600_000;
/** Bản sao cũ hơn chừng này → thẻ bot trên Boss cảnh báo "sao lưu đã cũ". */
export const SL_CU_SAU_MS = 48 * 3600_000;

/** Khoá chrome.storage.local ĐƯỢC sao lưu (danh sách TRẮNG: khoá mới không tự lọt vào bản sao). */
export const KHOA_SAO_LUU = [
  "settings", // Cài đặt (không chứa mật khẩu — mật khẩu ở "secrets")
  "schedules", // lịch chạy HH:MM
  "hanMucNgay", // bộ đếm việc đăng/gửi trong ngày (hạn mức) — mất thì chạy quá tay trong ngày khôi phục
  "hoSo", // hồ sơ (chủ đề, giọng…)
  "khoiTuyChinh", // khối tuỳ chỉnh của bản đồ
  "luatChanDoan", // luật chẩn đoán đã học
  "banDoGiaoDien", // khảo sát giao diện làm trên máy
  "xoayTuKhoa", // vị trí xoay từ khoá (không lặp từ khoá)
  "xoayTuKhoaGio",
  "kichban.anhDaDung", // ảnh đã dùng (không dùng lại ảnh)
  "kichban.deXuatSua.daGui", // đề xuất sửa đã gửi Boss
  "giuCuaSoKho", // cấu hình giữ cửa sổ
  "maMay", // mã máy (tên bot mặc định "Bot <mã>")
] as const;
export type KhoaSaoLuu = (typeof KHOA_SAO_LUU)[number];

/** Khoá CỐ Ý không sao lưu + lý do (hiện cho người dùng / tài liệu; test giữ danh sách này đúng). */
export const KHOA_KHONG_SAO_LUU: Record<string, string> = {
  secrets: "mật khẩu, khoá API — không gửi lên Boss dù đã mã hoá; khôi phục xong cần nhập lại",
  boss: "token ghép cặp — đi đường riêng (phiếu khôi phục trong cookie của trình duyệt), không nằm trong bản sao",
  bossPolicy: "Boss gửi lại khi bot nối",
  bossUnsynced: "danh sách lần chạy chưa báo Boss — thuộc phiên đang chạy",
  bossLastError: "trạng thái tạm",
  banDoBoss: "bản đồ giao diện tải từ Boss — Boss gửi lại",
  controlToken: "mã điều khiển cục bộ (cổng localhost) — bí mật của máy",
  saoLuuTrangThai: "trạng thái sao lưu của chính máy",
};

// ---------------- dạng bản sao ----------------
export interface BoQuaSaoLuu {
  /** TÊN các mục trong "secrets" (không có giá trị) → sau khi khôi phục báo "cần nhập lại". */
  secrets: string[];
  /** Ảnh dạy không sao lưu. */
  anhDay: number;
  /** Lần chạy đang chạy / chờ duyệt lúc sao lưu (không đưa vào). */
  lanChayDangDo: number;
  /** Lần chạy cũ bị bỏ vì bản sao vượt cỡ (bỏ CŨ NHẤT trước). */
  lanChayCat: number;
  /** Dòng sổ cái cũ bị bỏ vì vượt cỡ (chỉ khi riêng sổ cái đã quá cỡ — bỏ CŨ NHẤT trước). 0 = sổ cái đủ. */
  soCaiCat: number;
  /** Số ảnh data: trong lần chạy đã thay bằng chữ (ảnh màn hình chờ duyệt…). */
  anhTrongLanChay: number;
}

export interface BanSaoPlugin {
  dang: typeof DANG_SAO_LUU;
  phienBan: number;
  taoLuc: string;
  extVersion: string;
  idb: { ledger: unknown[]; runs: unknown[]; bundles: unknown[]; scripts: unknown[] };
  storage: Record<string, unknown>;
  boQua: BoQuaSaoLuu;
}

export interface DemBanSao { soCai: number; lanChay: number; banDaHoc: number; kichBan: number; khoa: number }

export function demBanSao(b: BanSaoPlugin): DemBanSao {
  return { soCai: b.idb.ledger.length, lanChay: b.idb.runs.length, banDaHoc: b.idb.bundles.length, kichBan: b.idb.scripts.length, khoa: Object.keys(b.storage).length };
}

/** Thông tin một bản sao lưu Boss đang giữ (không có nội dung). */
export interface MetaSaoLuu {
  id: string;
  botId: string;
  taoLuc: string;
  kichCo: number; // byte bản nén
  kichCoGoc: number; // byte JSON
  extVersion: string;
  dem: DemBanSao;
  /** Có khi chủ Boss CHÉP bản này từ bot khác (máy mới / ghép cặp lại). */
  tuBot?: { id: string; ten: string };
}

const laObj = (x: unknown): x is Record<string, unknown> => !!x && typeof x === "object" && !Array.isArray(x);
const laChuoi = (x: unknown): x is string => typeof x === "string";

/**
 * Kiểm một bản sao đọc từ mạng / tệp (KHÔNG tin): đúng dạng, đúng kiểu từng dòng cần cho việc gộp. Khoá storage lạ bị BỎ (không lỗi) — bản sao
 * từ plugin mới hơn có thể có thêm khoá. Phiên bản bản sao mới hơn bản này hiểu → lỗi rõ (đừng gộp nửa vời).
 */
export function kiemBanSao(x: unknown): { ok: true; banSao: BanSaoPlugin } | { ok: false; loi: string } {
  if (!laObj(x)) return { ok: false, loi: "không phải bản sao lưu (không phải đối tượng JSON)" };
  if (x.dang !== DANG_SAO_LUU) return { ok: false, loi: "không phải bản sao lưu của plugin Kịch bản" };
  const pb = x.phienBan;
  if (typeof pb !== "number" || !Number.isInteger(pb) || pb < 1) return { ok: false, loi: "bản sao lưu thiếu số phiên bản" };
  if (pb > PHIEN_BAN_SAO_LUU) return { ok: false, loi: `bản sao lưu dạng ${pb} do plugin mới hơn tạo — hãy cập nhật plugin rồi khôi phục lại` };
  if (!laChuoi(x.taoLuc) || Number.isNaN(Date.parse(x.taoLuc))) return { ok: false, loi: "bản sao lưu thiếu thời điểm tạo" };
  const idb = x.idb;
  if (!laObj(idb)) return { ok: false, loi: "bản sao lưu thiếu phần dữ liệu (idb)" };
  for (const k of ["ledger", "runs", "bundles", "scripts"] as const) if (!Array.isArray(idb[k])) return { ok: false, loi: `bản sao lưu hỏng: ${k} không phải danh sách` };
  const ledger = idb.ledger as unknown[], runs = idb.runs as unknown[], bundles = idb.bundles as unknown[], scripts = idb.scripts as unknown[];
  for (let i = 0; i < ledger.length; i++) {
    const r = ledger[i];
    if (!laObj(r) || !laChuoi(r.key) || !laChuoi(r.phamVi) || !laChuoi(r.ledger) || !laChuoi(r.item)) return { ok: false, loi: `bản sao lưu hỏng: dòng sổ cái thứ ${i + 1} không hợp lệ` };
  }
  for (let i = 0; i < runs.length; i++) {
    const r = runs[i];
    if (!laObj(r) || !laChuoi(r.id) || !r.id || !laChuoi(r.startedAt) || !laChuoi(r.bundleName) || !laChuoi(r.status)) return { ok: false, loi: `bản sao lưu hỏng: lần chạy thứ ${i + 1} không hợp lệ` };
  }
  for (let i = 0; i < bundles.length; i++) {
    const r = bundles[i];
    if (!laObj(r) || !laChuoi(r.name) || !r.name || !laObj(r.bundle)) return { ok: false, loi: `bản sao lưu hỏng: bản đã học thứ ${i + 1} không hợp lệ` };
  }
  for (let i = 0; i < scripts.length; i++) {
    const r = scripts[i];
    if (!laObj(r) || !laChuoi(r.name) || !r.name || !laChuoi(r.text)) return { ok: false, loi: `bản sao lưu hỏng: kịch bản thứ ${i + 1} không hợp lệ` };
  }
  if (!laObj(x.storage)) return { ok: false, loi: "bản sao lưu hỏng: storage không phải đối tượng" };
  const storage: Record<string, unknown> = {};
  for (const k of KHOA_SAO_LUU) if (k in x.storage && x.storage[k] !== undefined) storage[k] = x.storage[k];
  const bq = laObj(x.boQua) ? x.boQua : {};
  const so = (v: unknown): number => (typeof v === "number" && Number.isFinite(v) && v >= 0 ? Math.floor(v) : 0);
  const boQua: BoQuaSaoLuu = {
    secrets: Array.isArray(bq.secrets) ? bq.secrets.filter(laChuoi).slice(0, 200) : [],
    anhDay: so(bq.anhDay), lanChayDangDo: so(bq.lanChayDangDo), lanChayCat: so(bq.lanChayCat), soCaiCat: so(bq.soCaiCat), anhTrongLanChay: so(bq.anhTrongLanChay),
  };
  return { ok: true, banSao: { dang: DANG_SAO_LUU, phienBan: pb, taoLuc: x.taoLuc, extVersion: laChuoi(x.extVersion) ? x.extVersion.slice(0, 50) : "", idb: { ledger, runs, bundles, scripts }, storage, boQua } };
}

// ---------------- nén / giải nén (CompressionStream có ở service worker Chrome ≥ 80 và Node ≥ 18) ----------------
export async function nenGzip(text: string): Promise<Uint8Array> {
  const s = new Blob([text]).stream().pipeThrough(new CompressionStream("gzip"));
  return new Uint8Array(await new Response(s).arrayBuffer());
}

/** Giải nén có CHẶN cỡ: vượt `toiDa` byte → ném (không đọc tiếp — chống bom nén). Dữ liệu không phải gzip → ném. */
export async function giaiNenGzip(u: Uint8Array, toiDa = SL_GOC_TOI_DA): Promise<string> {
  const reader = new Blob([u as BlobPart]).stream().pipeThrough(new DecompressionStream("gzip")).getReader();
  const phan: Uint8Array[] = [];
  let tong = 0;
  for (;;) {
    let r: ReadableStreamReadResult<Uint8Array>;
    try { r = await reader.read(); } catch { throw new Error("bản sao lưu hỏng (không giải nén được)"); }
    if (r.done) break;
    tong += r.value.length;
    if (tong > toiDa) { await reader.cancel().catch(() => {}); throw new Error(`bản sao lưu quá lớn sau khi giải nén (> ${Math.round(toiDa / 1048576)} MB)`); }
    phan.push(r.value);
  }
  const all = new Uint8Array(tong);
  let o = 0;
  for (const p of phan) { all.set(p, o); o += p.length; }
  return new TextDecoder("utf-8", { fatal: false }).decode(all);
}

export function sangBase64(u: Uint8Array): string {
  let s = "";
  for (let i = 0; i < u.length; i += 0x8000) s += String.fromCharCode(...u.subarray(i, i + 0x8000));
  return btoa(s);
}

export function tuBase64(s: string): Uint8Array {
  if (!/^[A-Za-z0-9+/]*={0,2}$/.test(s) || s.length % 4 !== 0) throw new Error("dữ liệu base64 không hợp lệ");
  const b = atob(s);
  const u = new Uint8Array(b.length);
  for (let i = 0; i < b.length; i++) u[i] = b.charCodeAt(i);
  return u;
}

/** "1,2 MB" / "350 KB" / "900 B" — kích cỡ cho người đọc (dấu phẩy thập phân kiểu Việt). */
export function chuKichCo(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "?";
  if (n < 1024) return `${Math.round(n)} B`;
  if (n < 1048576) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1048576).toFixed(1).replace(".", ",")} MB`;
}
